export const ABOT_US_METRICS = [
    { title: "Fact one", number: 30, plus: "+", desc: "Developers" },
    { title: "Fact two", number: 10, plus: "", desc: "Current Clients" },
    { title: "Fact three", number: 30, plus: "+", desc: "Thriving partners" },
    {
        title: "Fact four",
        number: 4,
        years: true,
        plus: "+",
        desc: "In the market",
    },
    {
        title: "Fact five",
        number: 60,
        percent: true,
        plus: "%",
        desc: "Skilled professionals with a long-standing career",
    },
    {
        title: "Fact six",
        number: 2,
        years: true,
        plus: "+",
        desc: "Duration of partnership",
    },
]
